export function enviarFormularioRedsys(form: {
  url: string;
  Ds_SignatureVersion: string;
  Ds_MerchantParameters: string;
  Ds_Signature: string;
}) {
  const el = document.createElement("form");
  el.method = "POST";
  el.action = form.url;
  for (const [key, value] of Object.entries(form)) {
    if (key === "url") continue;
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = key;
    input.value = value;
    el.appendChild(input);
  }
  document.body.appendChild(el);
  el.submit();
}
